"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "IconButton__StyledButton",
  componentId: "veycn1-0"
})(["border-radius:50%;width:2.25rem;height:2.25rem;padding:0;min-width:2.25rem;min-height:2.25rem;"]);

var IconContainer = _styledComponents["default"].span.withConfig({
  displayName: "IconButton__IconContainer",
  componentId: "veycn1-1"
})(["display:flex;align-items:center;justify-content:center;margin:0;"]);
/**
 * The **IconButton** component renders a `<button>` with an icon and no text. For accessibility reasons, the **IconButton** should only be used sparingly and only with icons that are more broadly recognised (like Crosses and arrows for example). Make sure you provide an `ariaLabel` or the component will fail accessibility.
 */


var IconButton = function IconButton(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$toggleable = _ref.toggleable,
      toggleable = _ref$toggleable === void 0 ? false : _ref$toggleable,
      icon = _ref.icon,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["active", "disabled", "toggleable", "icon", "onClick", "children"]);

  return /*#__PURE__*/_react["default"].createElement(StyledButton, _extends({
    active: active,
    disabled: disabled,
    toggleable: toggleable,
    onClick: onClick
  }, rest), /*#__PURE__*/_react["default"].createElement(IconContainer, null, " ", icon && /*#__PURE__*/_react["default"].cloneElement(icon, {
    size: 24
  })), children);
};

var _default = IconButton;
exports["default"] = _default;